import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCloudOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <g clipPath='url(#cloud-off_svg__a)'>
      <path
        fill='currentColor'
        d='M21.69 16.56a1 1 0 1 0 1.84.78zM18 10v1h.001zm-1.26 0-.97.246a1 1 0 0 0 .97.754zM9.778 3.004a1 1 0 1 0-.176 1.992zM5.484 5.875a1 1 0 1 0-.968-1.75zM9 20v-1h-.016zm9 0v1h.001zm2.041.64a1 1 0 0 0-.682-1.88zM1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zm1.238-6.367a6 6 0 0 0 .45-2.894l-1.992.184a4 4 0 0 1-.3 1.93zm.45-2.894a6 6 0 0 0-.975-2.763l-1.667 1.106a4 4 0 0 1 .65 1.841zm-.975-2.763a6 6 0 0 0-2.166-1.971l-.945 1.762a4 4 0 0 1 1.444 1.315zM20.84 9.712A6 6 0 0 0 18 9L18 11a4 4 0 0 1 1.894.474zM18 9h-1.26v2H18zm-.29.754a9 9 0 0 0-2.89-4.639l-1.297 1.523a7 7 0 0 1 2.248 3.608zm-2.89-4.639a9 9 0 0 0-5.042-2.111l-.176 1.992a7 7 0 0 1 3.92 1.642zm-10.304-.99a9 9 0 0 0-3.925 4.35l1.84.784a7 7 0 0 1 3.053-3.384zM.591 8.475a9 9 0 0 0-.416 5.845l1.932-.515a7 7 0 0 1 .324-4.546zM.175 14.32a9 9 0 0 0 3.27 4.862l1.206-1.596a7 7 0 0 1-2.544-3.781zm3.27 4.862A9 9 0 0 0 9.017 21l-.032-2a7 7 0 0 1-4.333-1.414zM9 21h9v-2H9zm9.001 0c.696 0 1.386-.123 2.04-.36l-.682-1.88a4 4 0 0 1-1.36.24zM.293 1.707l22 22 1.414-1.414-22-22z'
      />
    </g>
    <defs>
      <clipPath id='cloud-off_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCloudOff;
